import React, { Component } from "react";

const expandIcon = ({ width, fill }) => {
  return (
    <svg width={width} height={width} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.31641 12.5V0.5H6.68441V12.5H6.31641Z" stroke={fill} />
      <path d="M6.68441 0.5H6.31641V12.5H6.68441V0.5Z" stroke={fill} />
      <path d="M0.5 6.31641L12.5 6.31641V6.68441L0.5 6.68441V6.31641Z" stroke={fill} />
      <path d="M12.5 6.68441V6.31641L0.5 6.31641V6.68441L12.5 6.68441Z" stroke={fill} />
    </svg>
  );
};

expandIcon.defaultProps = {
  width: 13,
  fill: "black",
};

export default expandIcon;
